import React, { ElementType } from 'react';
import { Button, Typography } from '@guildeducationinc/recess';
import { trackEvent } from 'src/services/analytics';
import ProgramQuizPictogram from '@guildeducationinc/recess/pictograms/ProgramQuizPictogram';
import { Link } from 'react-router-dom';
import styles from './NoQuizResults.module.scss';

export const NoQuizResults: React.FC = () => {
	return (
		<section className={styles.placeholderContainer} data-testid='no-quiz-results'>
			<ProgramQuizPictogram size={64} />
			<Typography className={styles.placeholderHeading} variant='h2'>
				Hmmm, we couldn&apos;t find the right fit.
			</Typography>
			<Typography className={styles.placeholderParagraph} variant='body1'>
				We couldn’t find programs that align with your education goals, current level of education,
				GPA, and interests. You can retake the quiz or view all available programs.
			</Typography>
			<Button
				Component={Link as unknown as ElementType}
				className='margin--top_16 margin--bottom_16'
				onClick={() =>
					trackEvent('Clickable', {
						tag: 'recommendationsTabStartProgramQuiz',
						text: 'Start Program Quiz',
						type: 'button',
					})
				}
				testid='results-quiz-cta'
				to='/quiz'
			>
				Retake the quiz
			</Button>
		</section>
	);
};
